import componentClasses from './component-style.js'
import { getCurrentInstance } from 'vue';

import dayjs from 'dayjs';

const methods = {
    vue: null,
    setInstance(vue) {
        this.vue = vue;
    },
    dateFormat(date,format) {
        return dayjs(date).format(format);
    },
    console_log(str) {
        console.log(str);
    },
    closeDropdown(id) {
        var theDropdown = FlowbiteInstances.getInstance('Dropdown', id);
        theDropdown.hide();
    },
    //blob 타입을 base64로 변환
    blobToBase64(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    },

    //지정된 언어로 공통코드명 리턴
    getCodeLangNameByCode(codeList, cd, langCode) {

        const fallbackLang = this.vue.config.fallbackLang;

        if (langCode == undefined || langCode == null)
            langCode = this.vue.$i18n.locale;

        if (codeList == undefined || codeList == null) return cd;

        //if (!codeList.some(item => item.hasOwnProperty(key))) return '';

        const item = codeList.find(item => item.codeCd === cd);

        if (item == undefined || item == null) return cd;

        var codeTrJsonParsed = {};
        var codeName = '';

        if (item.codeTrJson) {
            try {
                codeTrJsonParsed = JSON.parse(item.codeTrJson);
                codeName = codeTrJsonParsed[langCode] || "";
            } catch (e) {
                console.error("Failed to parse codeTrJson:", item, e);
            }

            try {
                if (codeName == '') {
                    codeName = codeTrJsonParsed[fallbackLang] || "";
                }
            } catch (e) {

            }

            try {
                if (codeName == '') {
                    codeName = codeTrJsonParsed['ko'] || "";
                }
            } catch (e) {

            }
        }

        return codeName;
    },
    //공통코드리스트에서 지정된 언어로 출력
    getCodeListByLang(list, vue, useOrderByName) {

        const fallbackLang = this.vue.config.fallbackLang;

        if (list == undefined || list == null) return list;

        //deep copy
        const data = JSON.parse(JSON.stringify(list));

        let langCode = vue.$i18n.locale;

        for (var i = 0; i < data.length; i++) {
            var country = data[i];
            var codeTrJsonParsed = {};
            if (country.codeTrJson) {
                try {
                    codeTrJsonParsed = JSON.parse(country.codeTrJson);
                    country.codeName = codeTrJsonParsed[langCode] || "";
                } catch (e) {
                    console.error("Failed to parse codeTrJson for country:", country, e);
                    country.codeName = '';
                }

                try {
                    if (country.codeName == '') {
                        country.codeName = codeTrJsonParsed[fallbackLang] || "";
                    }
                } catch (e) {
                    
                }

                try {
                    if (country.codeName == '') {
                        country.codeName = codeTrJsonParsed['ko'] || "";
                    }
                } catch (e) {
                    
                }

            } else {
                country.codeName = '';
            }
        }

        if (useOrderByName) {
            data.sort(function (a, b) {
                var aValue = a.codeName || "";
                var bValue = b.codeName || "";
                return aValue.localeCompare(bValue);
            });
        }

        return data;
    },

    //Select 클래스명 가져오기
    selectClasses(state, varient, disabled) {
        let style = 'default';

        if (state) style = state;

        if (disabled) style = 'disabled';
        
        return componentClasses(style, 'select', disabled, varient);
    },
    //탭 클래스명 가져오기
    tabClasses(active, varient, disabled) {
        let style = 'default';

        if (disabled) style = 'disabled';
        else {
            if (active) style = 'active';
        }
        return componentClasses(style, 'tab', disabled, varient);
    },
}


export default {
    install(Vue) {
        //Vue.config.globalProperties.$log = methods.console_log;
        Vue.config.globalProperties.f = methods;
    }
}

